var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.16632 3.97371C7.16632 5.78004 5.69984 7.24472 3.8906 7.246C2.0728 7.24729 0.607609 5.78047 0.612316 3.96386C0.617023 2.16224 2.09078 0.700133 3.89916 0.70313C5.70284 0.706127 7.16632 2.17123 7.16632 3.97371Z",
    fill: "#9E9BA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.43801 7.29688C3.08635 8.35696 4.6996 8.34797 6.34196 7.3033C6.34196 7.49211 6.34196 7.65866 6.34196 7.8252C6.34196 8.38136 6.33811 8.93709 6.34324 9.49325C6.34709 9.91454 6.1571 10.2207 5.79337 10.4099C5.41936 10.6043 5.04793 10.5649 4.7103 10.3136C4.43729 10.1106 4.1754 9.89313 3.89212 9.66878C3.61911 9.88243 3.34952 10.1008 3.07266 10.3089C2.52963 10.7156 1.7812 10.5251 1.5176 9.91497C1.48165 9.83234 1.44271 9.74157 1.44186 9.65423C1.43544 8.87929 1.43801 8.10478 1.43801 7.29688Z",
    fill: "#9E9BA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrades);
export default __webpack_public_path__ + "static/media/grades.50e1c2015e7b8cea6233d259edf1aa30.svg";
export { ForwardRef as ReactComponent };